module.exports = __webpack_public_path__ + "roboto-bolditalic-webfont.9652fff5f251d61fa54a.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-bolditalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-bolditalic-webfont.woff2
// module chunks = styles